const ZendeskRequestAT = {
  ZENDESK_REQUEST_CREATE_REQUEST: 'ZENDESK_REQUEST_CREATE_REQUEST',
  ZENDESK_REQUEST_CREATE_SUCCESS: 'ZENDESK_REQUEST_CREATE_SUCCESS',
  ZENDESK_REQUEST_CREATE_FAILURE: 'ZENDESK_REQUEST_CREATE_FAILURE',
} as const;

export default {
  ...ZendeskRequestAT,
};
